<template>
    <form @submit.prevent="onSubmit()" @keydown="form.$errors.clear($event.target.name);">
        <div class="card card-form">
            <div class="row no-gutters">
                <div class="col-xl-9 p-3">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-group :label="$t('[[[Nazwa użytkownika]]]')" :feedback="form.$errors.first('userName')" :state="form.$errors.state('userName')" v-required>
                                <b-form-input v-model="form.userName" type="text" name="userName" v-focus></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('[[[Imię]]]')" :feedback="form.$errors.first('givenName')" :state="form.$errors.state('givenName')">
                                <b-form-input v-model="form.givenName" type="text" name="givenName"></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('[[[Nazwisko]]]')" :feedback="form.$errors.first('surname')" :state="form.$errors.state('surname')">
                                <b-form-input v-model="form.surname" type="text" name="surname"></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('[[[E-mail]]]')" :feedback="form.$errors.first('email')" :state="form.$errors.state('email')" v-required>
                                <b-form-input v-model="form.email" type="email" name="email"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-checkbox v-model="form.emailConfirmed">{{ $t('[[[Adres e-mail potwierdzony]]]') }}</b-form-checkbox>
                            </b-form-group>
                        </div>
                    </div>
                </div>
                <div class="col-xl-3 p-3 bg-light">
                    <div class="row">
                        <div class="col-xl-12 col-sm-6">
                            <b-form-group :label="$t('[[[Zdjęcie użytkownika]]]')" :feedback="form.$errors.first('facePicture')" :state="form.$errors.state('facePicture')">
                                <fileupload v-model="form.facePicture" :maxFiles="1" :accept="['image/jpeg', 'image/png']"></fileupload>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Przyciski -->
            <div class="card-footer">
                <responsive>
                    <button type="submit" class="btn btn-primary" :disabled="form.disabled()">
                        <i class="fas fa-check"></i> {{ $t('[[[Zapisz]]]') }}
                    </button>
                    <router-link class="btn btn-light ml-2" :to="{name:'home'}">
                        <i class="far fa-arrow-alt-circle-left"></i> {{ $t('[[[Powrót]]]') }}
                    </router-link>
                </responsive>
            </div>
        </div>
    </form>
</template>

<script>
import Form from '@/helpers/Form';
import AuthService from '@/services/core/AuthService';
import StorageService from '@/services/core/StorageService';

export default
{
    data: function()
    {
        return {
            form: Form.create({
                userName: '',
                email: '',
                givenName: '',
                surname: '',
                facePicture: null
            })
        };
    },

    created: function()
    {
        this.loadData();
    },

    methods: {
        async loadData()
        {
            this.form.withData(this.$auth.user());
        },

        async onSubmit()
        {
            try
            {
                this.form.disable();

                if (this.form.facePicture && this.form.facePicture.upload)
                {
                    this.form.facePicture = await StorageService.upload(this.form.facePicture);
                }

                await AuthService.updateProfile(this.form.data());
                await AuthService.fetchUser();
                await this.loadData();

                this.form.enable();
                this.$alert.success(this.$t('[[[Profil został zaktualizowany.]]]'));
            }
            catch (ex)
            {
                this.form.enable();

                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                if (ex.code === 422)
                    this.form.$errors.record(ex.data.errors);

                this.$log.debug(ex);
            }
        }
    }
};
</script>

<style scoped>
.card {
    margin-top: 60px;
}
</style>
